<template>
  <section class="guest-detail" style="margin-top: 16px">
    <div class="guests-page__head" style="margin: 0 0 12px">
      <div>
        <h3 class="detail-block-title" style="margin: 0">Stock farmaci</h3>
        <p class="guests-page__subtitle">
          Giacenza dosi dei farmaci personali e movimenti (carichi, scarichi da
          somministrazione FEFO, rettifiche). Vista gestionale, non clinica.
        </p>
      </div>
      <button
        class="villa-btn villa-btn--ghost"
        :disabled="loading"
        @click="load"
      >
        <i
          :class="
            loading ? 'fa-solid fa-spinner fa-spin' : 'fa-solid fa-rotate'
          "
        ></i>
        Aggiorna
      </button>
    </div>

    <div v-if="loading" class="guests-loading">Caricamento…</div>
    <template v-else>
      <!-- Overview giacenza per farmaco -->
      <div v-if="!overview.length" class="guests-loading">
        Nessun farmaco personale con stock.
      </div>
      <div v-else class="guests-table-wrap">
        <table class="guests-table">
          <thead>
            <tr>
              <th>Farmaco</th>
              <th>Giacenza (dosi)</th>
              <th>Carichi</th>
              <th>Scadenza più vicina</th>
              <th>Ultimo movimento</th>
              <th v-if="canManage" class="actions-cell">Azioni</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="o in overview" :key="o.medicationItemId">
              <td>{{ o.name }}</td>
              <td>
                <span :class="{ 'mstock-out': o.outOfStock }">
                  {{ o.totalRemaining }} {{ o.doseUnit }}
                </span>
                <span
                  v-if="o.outOfStock"
                  class="status-badge status-badge--suspended"
                  style="margin-left: 6px"
                >
                  esaurito
                </span>
              </td>
              <td>{{ o.loadsCount }}</td>
              <td>{{ o.nearestExpiry ? fmtDate(o.nearestExpiry) : "—" }}</td>
              <td>
                {{ o.lastMovementAt ? fmtDateTime(o.lastMovementAt) : "—" }}
              </td>
              <td v-if="canManage" class="actions-cell">
                <button
                  class="icon-btn"
                  title="Rettifica giacenza"
                  @click="openAdjust(o)"
                >
                  <i class="fa-solid fa-sliders"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Movimenti -->
      <h4 class="detail-block-title" style="font-size: 14px; margin-top: 18px">
        Movimenti stock
      </h4>
      <div
        v-if="!movements.length"
        class="guests-loading"
        style="padding: 12px"
      >
        Nessun movimento registrato.
      </div>
      <div v-else class="guests-table-wrap">
        <table class="guests-table">
          <thead>
            <tr>
              <th>Data</th>
              <th>Farmaco</th>
              <th>Tipo</th>
              <th>Dosi</th>
              <th>Prima → Dopo</th>
              <th class="actions-cell"></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="m in movements"
              :key="m.id"
              :class="{ 'mstock-voided': m.status === 'voided' }"
            >
              <td>{{ fmtDateTime(m.createdAt) }}</td>
              <td>{{ m.medicationName || "—" }}</td>
              <td>
                {{ mvLabel(m.movementType) }}
                <span
                  v-if="m.status === 'voided'"
                  class="status-badge status-badge--deceased"
                  :title="m.voidReason || ''"
                >
                  annullato
                </span>
              </td>
              <td>{{ m.quantity }}</td>
              <td>
                {{ m.previousStock != null ? m.previousStock : "—" }} →
                {{ m.resultingStock != null ? m.resultingStock : "—" }}
              </td>
              <td class="actions-cell">
                <button
                  v-if="
                    isAdminUser &&
                    m.status !== 'voided' &&
                    [
                      'administration',
                      'manual_adjustment',
                      'correction',
                    ].includes(m.movementType)
                  "
                  class="icon-btn icon-btn--danger"
                  title="Annulla movimento"
                  @click="openVoid(m)"
                >
                  <i class="fa-solid fa-rotate-left"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>

    <!-- Modale rettifica (seleziona carico + nuove dosi residue) -->
    <div
      v-if="adjustModal.open"
      class="villa-modal-backdrop"
      @click.self="adjustModal.open = false"
    >
      <div class="villa-confirm" style="max-width: 460px">
        <h3 class="villa-confirm__title">
          Rettifica giacenza — {{ adjustModal.itemName }}
        </h3>
        <div v-if="adjustModal.loadsLoading" class="guests-loading">
          Caricamento carichi…
        </div>
        <template v-else>
          <div v-if="!adjustModal.loads.length" class="guests-loading">
            Nessun carico attivo per questo farmaco.
          </div>
          <div v-else class="form-grid" style="margin-bottom: 16px">
            <div class="form-field form-field--full">
              <label>Carico</label>
              <select v-model.number="adjustModal.loadId" class="search-box">
                <option
                  v-for="l in adjustModal.loads"
                  :key="l.id"
                  :value="l.id"
                >
                  {{ l.lotNumber ? "Lotto " + l.lotNumber : "Carico #" + l.id }}
                  · scad. {{ l.expiryDate ? fmtDate(l.expiryDate) : "n/d" }} ·
                  residue {{ l.remainingDoses }}/{{ l.totalDoses }}
                </option>
              </select>
            </div>
            <div class="form-field">
              <label>Nuove dosi residue</label>
              <input
                v-model.number="adjustModal.newRemaining"
                type="number"
                min="0"
              />
            </div>
            <div class="form-field form-field--full">
              <label>Motivo / nota</label>
              <input v-model.trim="adjustModal.note" type="text" />
            </div>
          </div>
        </template>
        <div class="villa-confirm__actions">
          <button
            class="villa-btn villa-btn--ghost"
            :disabled="adjustModal.busy"
            @click="adjustModal.open = false"
          >
            Annulla
          </button>
          <button
            class="villa-btn villa-btn--primary"
            :disabled="adjustModal.busy || !adjustModal.loads.length"
            @click="submitAdjust"
          >
            {{ adjustModal.busy ? "Salvataggio…" : "Salva rettifica" }}
          </button>
        </div>
      </div>
    </div>

    <!-- Modale annullamento movimento -->
    <div
      v-if="voidModal.open"
      class="villa-modal-backdrop"
      @click.self="voidModal.open = false"
    >
      <div class="villa-confirm" style="max-width: 440px">
        <h3 class="villa-confirm__title">Annulla movimento</h3>
        <p class="villa-confirm__text">
          L'operazione è tracciata e ripristina le dosi sul carico interessato.
        </p>
        <div class="form-field form-field--full" style="margin-bottom: 16px">
          <label>Motivo <span class="required">*</span></label>
          <textarea v-model.trim="voidModal.reason" rows="2"></textarea>
        </div>
        <div class="villa-confirm__actions">
          <button
            class="villa-btn villa-btn--ghost"
            :disabled="voidModal.busy"
            @click="voidModal.open = false"
          >
            Annulla
          </button>
          <button
            class="villa-btn villa-btn--danger"
            :disabled="voidModal.busy"
            @click="confirmVoid"
          >
            {{ voidModal.busy ? "Annullamento…" : "Conferma" }}
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

const MV = {
  load: "Carico",
  administration: "Somministrazione",
  manual_adjustment: "Rettifica",
  correction: "Correzione",
  void: "Annullo",
};

export default {
  name: "GuestMedicationStockPanel",
  props: { guestId: { type: [String, Number], required: true } },
  data() {
    return {
      loading: true,
      overview: [],
      movements: [],
      adjustModal: {
        open: false,
        busy: false,
        loadsLoading: false,
        itemId: null,
        itemName: "",
        loads: [],
        loadId: null,
        newRemaining: 0,
        note: "",
      },
      voidModal: { open: false, busy: false, movementId: null, reason: "" },
    };
  },
  computed: {
    ...mapGetters(["isAdminUser", "canManage"]),
  },
  methods: {
    ...mapActions([
      "fetchMedicationStockOverview",
      "fetchMedicationStockMovements",
      "createMedicationStockAdjustment",
      "voidMedicationStockMovement",
      "fetchGuestMedicationStockLoads",
    ]),
    mvLabel: (t) => MV[t] || t,
    fmtDate(d) {
      if (!d) return "—";
      const s = String(d).slice(0, 10).split("-");
      return s.length === 3 ? `${s[2]}/${s[1]}/${s[0]}` : d;
    },
    fmtDateTime(d) {
      if (!d) return "—";
      const dt = new Date(d);
      if (Number.isNaN(dt.getTime())) return "—";
      const p = (n) => String(n).padStart(2, "0");
      return `${p(dt.getDate())}/${p(dt.getMonth() + 1)} ${p(
        dt.getHours()
      )}:${p(dt.getMinutes())}`;
    },
    async load() {
      this.loading = true;
      try {
        const [ov, mv] = await Promise.all([
          this.fetchMedicationStockOverview(this.guestId),
          this.fetchMedicationStockMovements({ guestId: this.guestId }),
        ]);
        this.overview = ov;
        this.movements = mv;
      } catch (err) {
        this.$toast.error(
          err?.response?.data?.message ||
            "Caricamento stock farmaci non riuscito."
        );
      } finally {
        this.loading = false;
      }
    },
    async openAdjust(o) {
      this.adjustModal = {
        open: true,
        busy: false,
        loadsLoading: true,
        itemId: o.medicationItemId,
        itemName: o.name,
        loads: [],
        loadId: null,
        newRemaining: 0,
        note: "",
      };
      try {
        const loads = await this.fetchGuestMedicationStockLoads({
          guestId: this.guestId,
          itemId: o.medicationItemId,
        });
        this.adjustModal.loads = loads;
        if (loads.length) {
          this.adjustModal.loadId = loads[0].id;
          this.adjustModal.newRemaining = loads[0].remainingDoses;
        }
      } catch {
        this.adjustModal.loads = [];
      } finally {
        this.adjustModal.loadsLoading = false;
      }
    },
    async submitAdjust() {
      this.adjustModal.busy = true;
      try {
        await this.createMedicationStockAdjustment({
          guestId: this.guestId,
          payload: {
            medicationItemId: this.adjustModal.itemId,
            stockLoadId: this.adjustModal.loadId,
            newRemaining: this.adjustModal.newRemaining,
            note: this.adjustModal.note,
          },
        });
        this.$toast.success("Rettifica registrata.");
        this.adjustModal.open = false;
        await this.load();
      } catch (err) {
        this.$toast.error(
          err?.response?.data?.message || "Rettifica non riuscita."
        );
      } finally {
        this.adjustModal.busy = false;
      }
    },
    openVoid(m) {
      this.voidModal = {
        open: true,
        busy: false,
        movementId: m.id,
        reason: "",
      };
    },
    async confirmVoid() {
      if (!this.voidModal.reason) {
        return this.$toast.error("Inserisci il motivo.");
      }
      this.voidModal.busy = true;
      try {
        await this.voidMedicationStockMovement({
          guestId: this.guestId,
          movementId: this.voidModal.movementId,
          reason: this.voidModal.reason,
        });
        this.$toast.success("Movimento annullato.");
        this.voidModal.open = false;
        await this.load();
      } catch (err) {
        this.$toast.error(
          err?.response?.data?.message || "Annullamento non riuscito."
        );
      } finally {
        this.voidModal.busy = false;
      }
    },
  },
  mounted() {
    this.load();
  },
};
</script>

<style src="@/css/GuestsPage.css" />
<style scoped>
.villa-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(8, 43, 87, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 16px;
}
.mstock-out {
  color: #b91c1c;
  font-weight: 700;
}
.mstock-voided td {
  opacity: 0.55;
  text-decoration: line-through;
}
.mstock-voided td:last-child {
  text-decoration: none;
}
</style>
